import { render, staticRenderFns } from "./ScaleAging.vue?vue&type=template&id=d9d33d2a&scoped=true&"
import script from "./ScaleAging.vue?vue&type=script&lang=js&"
export * from "./ScaleAging.vue?vue&type=script&lang=js&"
import style0 from "./ScaleAging.vue?vue&type=style&index=0&id=d9d33d2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9d33d2a",
  null
  
)

export default component.exports